export var RenVMType;
(function (RenVMType) {
    RenVMType["Address"] = "address";
    RenVMType["Str"] = "str";
    RenVMType["B32"] = "b32";
    RenVMType["B"] = "b";
    RenVMType["I8"] = "i8";
    RenVMType["I16"] = "i16";
    RenVMType["I32"] = "i32";
    RenVMType["I64"] = "i64";
    RenVMType["I128"] = "i128";
    RenVMType["I256"] = "i256";
    RenVMType["U8"] = "u8";
    RenVMType["U16"] = "u16";
    RenVMType["U32"] = "u32";
    RenVMType["U64"] = "u64";
    RenVMType["U128"] = "u128";
    RenVMType["U256"] = "u256";
    RenVMType["Record"] = "record";
    RenVMType["List"] = "list";
    // Ext
    RenVMType["ExtTypeEthCompatAddress"] = "ext_ethCompatAddress";
    RenVMType["ExtTypeBtcCompatUTXO"] = "ext_btcCompatUTXO";
    RenVMType["ExtTypeBtcCompatUTXOs"] = "ext_btcCompatUTXOs";
    RenVMType["ExtTypeEthCompatTx"] = "ext_ethCompatTx";
    RenVMType["ExtEthCompatPayload"] = "ext_ethCompatPayload";
})(RenVMType || (RenVMType = {}));
//# sourceMappingURL=value.js.map